import React from 'react'
import { useSelector } from 'react-redux'
import { NavLink } from 'react-router-dom'

import { getCurrentCandidate } from '@/core/selectors/candidate'
import { getIsLinkActive } from '@/core/helpers/navigationHelpers'

import NavDropdown, { DropdownLink } from '../NavDropdown'

import styles from './styles'

/**
 * NavMenu component
 *
 * @param {Object} props
 * @param {string} [props.candidateState]
 * @param {boolean} [props.disabledCandidate]
 * @param {number} [props.unreadInterviewRequestCount]
 * @param {() => void} [props.signOut]
 * @param {string} [props.emailPreferencesAccessTokenKey]
 *
 * @returns {JSX.Element}
 */
const NavMenu = ({ candidateState, disabledCandidate, unreadInterviewRequestCount, signOut, emailPreferencesAccessTokenKey }) => {
  const { id: candidateId, slug: candidateSlug } = useSelector(getCurrentCandidate)

  return (
    <ul className={styles.navigation}>
      <li>
        <NavLink
          exact
          to={`/candidate/${candidateId}/dashboard`}
          isActive={getIsLinkActive({ candidateId, candidateSlug, page: 'dashboard' })}
          className={styles.link}
          activeClassName={styles.activeLink}>
          Dashboard
        </NavLink>
      </li>

      <li>
        <NavLink
          exact
          to={`/candidate/${candidateId}`}
          isActive={getIsLinkActive({ candidateId, candidateSlug })}
          className={styles.link}
          activeClassName={styles.activeLink}>
          Profile
        </NavLink>
      </li>

      <li>
        <NavLink
          to={`/candidate/${candidateId}/applications`}
          className={styles.link}
          activeClassName={styles.activeLink}
          isActive={getIsLinkActive({ candidateId, candidateSlug, page: 'applications' })}>
          Jobs
        </NavLink>
      </li>

      <If condition={!disabledCandidate}>
        <li>
          <NavLink
            to={`/candidate/${candidateId}/interview_requests`}
            isActive={getIsLinkActive({ candidateId, candidateSlug, page: 'interview_requests' })}
            className={styles.link}
            activeClassName={styles.activeLink}>
            Interviews
            <If condition={unreadInterviewRequestCount > 0}>
              <span className={styles.unread}>{unreadInterviewRequestCount}</span>
            </If>
          </NavLink>
        </li>
      </If>

      <If condition={['ready_to_go_live', 'live', 'post_live'].includes(candidateState)}>
        <li>
          <a href={`/candidate/${candidateId}/calendar`} className={styles.link}>
            Calendar
          </a>
        </li>
      </If>

      <li>
        <NavDropdown className={styles.dropdown} label="More">
          <DropdownLink label="Account details" href={`/candidate/${candidateId}/account/details`} />
          <DropdownLink label="Email preferences" href={`/email_preferences/${emailPreferencesAccessTokenKey}`} />
          <DropdownLink label="Manage your data" href={`/candidate/${candidateId}/account/manage_data`} />
          <DropdownLink label="Invite Friends" href={`/candidate/${candidateId}/referrals`} />
          <DropdownLink label="Privacy Centre" href="/privacy-centre" target="_blank" />
          <DropdownLink label="Help" target="_blank" href="https://docs.offerzen.com/en/collections/111151-candidate-guides" />
          <DropdownLink label="Log out" onClick={signOut} rel="nofollow" />
        </NavDropdown>
      </li>
    </ul>
  )
}

export default NavMenu
